module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/7-1.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "chapter"
  }, [_vm._v("tilly the doll")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('strong', [_vm._v("Who’s that striding around the place?")]), _vm._v(" Oh, we should have guessed – it’s jolly Ms Tilly the dolly. She’s an energetic, oudoorsy sort of gal, bounding along on those gangly long legs with her ponytails flying in the wind – and she’s great fun and bubbly with it. But to be honest, her head is in the clouds in more than the literal sense.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_vm._v("Making Tilly, however, is a straightforward, down-to-earth business using standard soft toy-making and sewing techniques plus a little embroidery for her sweet rosy-cheeked face. And to finish off, you’ll need to do some simple fabric painting for her shoes.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/7-2.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "center"
  }, [_c('strong', [_vm._v("you will need")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• 30cm × 50cm (12in × 20in) green patterned cotton fabric (body and upper arms)")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• 25cm × 40cm (10in × 16in) pink striped cotton fabric (legs)")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• 30cm × 50cm (12in × 20in) calico (arms and head)")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• 30cm × 30cm (12in × 12in) small pink checked cotton fabric (hair)")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• 25cm × 60cm (10in × 24in) yellow patterned cotton fabric (pantaloons)")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• 15cm × 15cm (6in × 6in) fusible webbing")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• Six-strand embroidery thread (floss): brown and pink")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• Pink acrylic folk art paint")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• Acrylic folk art matt varnish")]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("• "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/tool.htm#sec1"
    }
  }, [_vm._v("Basic tool kit")])]), _vm._v(" "), _c('p', {
    staticClass: "hanging"
  }, [_vm._v("Finished size: about 40cm (16in) tall")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/8-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("one")]), _vm._v(" Trace all the "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/temp.htm#sec2"
    }
  }, [_vm._v("templates for Tilly")]), _vm._v(" onto template plastic, transferring all the markings, and cut them out around the outside lines.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("two")]), _vm._v(" Fold the green patterned fabric in half, right sides together. Draw around the body template once onto the folded fabric, "), _c('strong', [_vm._v("but don’t cut out")]), _vm._v(", as this will be sewn before cutting out.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("three")]), _vm._v(" Fold the pink striped fabric in half, right sides together. Draw around the leg template twice onto the folded fabric, ensuring that you line up the stripes accurately. "), _c('strong', [_vm._v("Don’t cut out")]), _vm._v(", as these will be sewn before cutting out.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/9-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Tilly’s characteristic lanky look is all in her legs, and the bold yet uniform stripy fabric really emphasizes her strongest feature, contrasting with the patterned pantaloons. Just make sure those stripes match up along the seams.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("four")]), _vm._v(" For Tilly’s arms, cut one strip of green patterned fabric measuring 5cm × 50cm (2in × 20in) and one strip of calico measuring 13cm × 50cm (5in × 20in). Sew the green strip to the top of the calico strip along the 50cm (20in) edge. Open out and press.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("five")]), _vm._v(" Fold the fabric panel for the arm in half, right sides together, so that the fabrics meet each other horizontally. Press. Draw around the arm template twice onto the folded fabric panel, ensuring that you line up the sleeve line on the template with the green fabric. "), _c('strong', [_vm._v("Don’t cut out")]), _vm._v(", as these will be sewn before cutting out.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("six")]), _vm._v(" Cut a piece of calico measuring 15cm × 13cm (6in × 5in). Draw around Tilly’s head template onto the wrong side of the single fabric. Flip the calico piece over and place, drawn-side down, on a light box or against a sunny window. Using a light grey lead pencil, draw the head shape onto the right side of the fabric, ensuring that it lines up exactly with the drawing on the wrong side of the fabric. This is done so that you can accurately position Tilly’s wig piece overlay.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("seven")]), _vm._v(" Draw around Tilly’s wig piece onto the paper side of the fusible webbing. Cut two pieces of pink checked fabric measuring 15in × 13in (6in × 5in). Iron the fusible webbing to the wrong side of one fabric piece. Cut out the wig piece overlay on the solid (not dotted) outside line.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("eight")]), _vm._v(" Remove the paper backing and position the wig piece carefully over the right side of Tilly’s head panel, using your pencil drawing to help you accurately position the hair over the face area. Press to fuse the two fabrics together. Hand "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/tool.htm#sec78"
    }
  }, [_vm._v("backstitch")]), _vm._v(" or "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/tool.htm#sec79"
    }
  }, [_vm._v("blanket stitch")]), _vm._v(" (or "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/tool.htm#sec63"
    }
  }, [_vm._v("machine stitch")]), _vm._v(" using a tight zigzag stitch) the inside edge of Tilly’s hair.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/10-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("nine")]), _vm._v(" Place the other piece of pink checked fabric, right sides together, on the front of Tilly’s head panel. Sew Tilly’s head together along the outside line that you had previously marked, "), _c('strong', [_vm._v("but don’t leave a turning gap")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("ten")]), _vm._v(" Cut Tilly’s head out 6mm ("), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("4")]), _vm._v("in) outside the stitched line. Cut a small slit in the "), _c('strong', [_vm._v("back only (pink fabric side)")]), _vm._v(" of Tilly’s head, positioned horizontally at the centre bottom, approximately 1.25cm ("), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("2")]), _vm._v("in) up from the stitched line. Turn the head right side out through the small slit.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("eleven")]), _vm._v(" Stuff the head firmly with toy filling and then overstitch the opening closed at the back of the head.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("twelve")]), _vm._v(" "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/tool.htm#sec63"
    }
  }, [_vm._v("Machine stitch")]), _vm._v(" the body and legs along the marked outside lines, leaving the ends open for turning. Machine stitch the arms together along the marked outside line, leaving the gap open for turning as on the template.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/11-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Instead of conventional doll’s hair, Tilly has an eccentric pink checked wig as befits her character – another way in which she stands out from the crowd. Note where the separate stuffed ponytails are attached.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("thirteen")]), _vm._v(" Cut out the body, legs and arms approximately 6mm ("), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("4")]), _vm._v("in) outside the stitched lines. Turn right sides out.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("fourteen")]), _vm._v(" Stuff the arms firmly with toy filling and "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/tool.htm#sec69"
    }
  }, [_vm._v("ladder stitch")]), _vm._v(" the "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/tool.htm#sec65"
    }
  }, [_vm._v("openings closed")]), _vm._v(". Stuff the legs firmly to the fill line. "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/tool.htm#sec63"
    }
  }, [_vm._v("Machine sew")]), _vm._v(" across the fill line, leaving the tops of the legs empty. Following the "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/tool.htm#sec95"
    }
  }, [_vm._v("Inserting Legs")]), _vm._v(" technique, insert the legs. Stuff the body firmly with toy filling and "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/tool.htm#sec69"
    }
  }, [_vm._v("ladder stitch")]), _vm._v(" the opening between the legs closed.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("fifteen")]), _vm._v(" Take the body and place the head over the top of the body, overlapping the stuffing slit in the head. Following the "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/tool.htm#sec67"
    }
  }, [_vm._v("Attaching Parts with Ladder Stitch technique")]), _vm._v(", ladder stitch the head onto the body where indicated on the body template, right around the seam line of the top of the body. This stitching should cover the stuffing slit and keep the head firmly in place.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("sixteen")]), _vm._v(" Ladder stitch the top 1.75cm (¾in) of each arm to the side of Tilly’s body.")]), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('h1', {
    staticClass: "section"
  }, [_vm._v("Tip")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('strong', [_vm._v("You can add an extra dimension of personality by attaching Tilly’s head to her body at a slight angle")]), _vm._v(".")])]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/12-2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Tilly’s long, slender arms add to her animated appearance, and they cleverly incorporate her blouse sleeve, the patterned fabric being sewn to the calico before cutting out. See here where her arms are ladder stitched to her body.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/13-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("seventeen")]), _vm._v(" Using a vanishing marker, draw the eyes, mouth and cheeks onto Tilly’s face. Use three strands of brown embroidery thread (floss) to embroider the eyes using "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/tool.htm#sec74"
    }
  }, [_vm._v("satin stitch")]), _vm._v(". Using three strands of pink embroidery thread (floss), embroider the cheeks with "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/tool.htm#sec66"
    }
  }, [_vm._v("running stitch")]), _vm._v(" and the mouth with "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/tool.htm#sec78"
    }
  }, [_vm._v("backstitch")]), _vm._v(" – you should be able to hide the knot behind Tilly’s head, in between her head and her body.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("eighteen")]), _vm._v(" Draw around the ponytail template twice onto the remaining pink checked fabric folded in half. Sew along the drawn lines, leaving the ends open. Cut out each ponytail 6mm ("), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("4")]), _vm._v("in) outside the stitched outline. Clip the curves and turn right sides out.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("nineteen")]), _vm._v(" Stuff each ponytail with toy filling. Turn the ends under by 6mm ("), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("4")]), _vm._v("in) and ladder stitch the ponytail into position on Tilly’s head, making sure that you line up each ponytail with the bottom of Tilly’s hairline.")]), _vm._v(" "), _c('p', {
    staticClass: "center"
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "OEBPS/images/14-1.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "caption"
  }, [_vm._v("Wearing pantaloons rather than a frock means that Tilly is suitably clad for any adventure she fancies – the trouser hems are sewn to her legs to keep them securely in place. And she’s wearing go-anywhere shoes.")]), _vm._v(" "), _c('h2', {
    staticClass: "section"
  }, [_c('a', {
    attrs: {
      "id": "sec111"
    }
  }), _vm._v("TILLY’S CLOTHES AND SHOES")]), _vm._v(" "), _c('p', {
    staticClass: "nonindent"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("one")]), _vm._v(" Draw around the pantaloon template onto the yellow patterned fabric folded in half and cut out on the drawn line. Machine stitch the two pantaloon pieces together along both the crotch seam lines as marked on the template, taking a 6mm ("), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("4")]), _vm._v("in) seam. Pull the seams to the front and back and machine stitch up one leg and then down the other.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("two")]), _vm._v(" Turn the waist and leg bottoms under by 1.25cm ("), _c('sup', {
    staticClass: "fnum"
  }, [_vm._v("1")]), _vm._v("⁄"), _c('sub', {
    staticClass: "fden"
  }, [_vm._v("2")]), _vm._v("in) and press. Using six strands of pink embroidery thread (floss), hand sew medium running stitches along the edge of the waist, without securing the thread at the end. Place the pantaloons on Tilly, pull the unsecured thread end to gather up the fabric evenly and tie securely in a knot. Sew the pantaloons to Tilly’s body by taking the thread through her body and out the back of the pantaloons, then back through to the front before tying in a knot.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("three")]), _vm._v(" Gather the leg bottoms in the same way, sewing them to the legs as in the previous step so that they remain at the same level.")]), _vm._v(" "), _c('p', {
    staticClass: "extract"
  }, [_c('span', {
    staticClass: "big"
  }, [_vm._v("four")]), _vm._v(" Using your lead pencil, draw the shoe line onto Tilly’s feet as marked on the template. Paint and then varnish the shoes following the "), _c('a', {
    staticClass: "hlink",
    attrs: {
      "href": "#/OEBPS/tool.htm#sec16"
    }
  }, [_vm._v("Painting on Fabric technique.")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-42756142","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/OEBPS/c01.vue
// module id = 66
// module chunks = 0